function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import Colors from "styles/colors";
import VerticalTabs from "segments/desktop/core-components/vertical-tabs/vertical-tabs";
import { isDarkTheme } from "segments/segments-service";
import AssetComponent from "components/core/asset/asset-component";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import { StyledTimelineTitledTabTabsComponent } from "./timeline-titled-tab-tabs-component.scss";
import DefaultProps from "./default-props";
const EMPTY_ASSET_TITLE_PROPS = {
    topic: {},
    body: ""
};
export const TAB_LINE_HEIGHT = 40;
const DEFAULT_TITLE = {
    title: ""
};
const DEFAULT_MOBILE_TEXT_AND_ASSET = {
    asset: {},
    fullParagraph: _object_spread_props(_object_spread({}, EMPTY_ASSET_TITLE_PROPS), {
        title: null
    })
};
const TimelineTitledTabTabsComponent = (_param)=>{
    var { fullBackground, theme, titles, contentHeight, advancedAssetTitleConfig, titlesColor, contentGap, tabAdvancedConfig } = _param, rest = _object_without_properties(_param, [
        "fullBackground",
        "theme",
        "titles",
        "contentHeight",
        "advancedAssetTitleConfig",
        "titlesColor",
        "contentGap",
        "tabAdvancedConfig"
    ]);
    const getTabTextAndAssetMobileProp = useCallback(({ asset, title })=>({
            asset,
            fullParagraph: _object_spread({}, EMPTY_ASSET_TITLE_PROPS, title)
        }), []);
    const tabsWithClassNames = useMemo(()=>titles.reduce((tabs, title)=>[
                ...tabs,
                {
                    tabLabel: title.tabsTitle,
                    tabClassName: "tab-title",
                    isDisabled: true,
                    tabDisabledColor: titlesColor,
                    textAndAsset: DEFAULT_MOBILE_TEXT_AND_ASSET
                },
                ...title.tabs.map((tab)=>_object_spread_props(_object_spread({}, tab), {
                        tabClassName: "nested-tab",
                        textAndAsset: getTabTextAndAssetMobileProp(tab)
                    }))
            ], []), [
        titles,
        titlesColor,
        getTabTextAndAssetMobileProp
    ]);
    const componentHeight = useMemo(()=>contentHeight || `${tabsWithClassNames.length * TAB_LINE_HEIGHT}px`, [
        contentHeight,
        tabsWithClassNames.length
    ]);
    const tabsTitleRenderer = ()=>null;
    const tabContentRenderer = ({ asset, title })=>/*#__PURE__*/ _jsxs("div", {
            className: "asset-and-text",
            style: {
                height: componentHeight.toString(),
                gap: contentGap
            },
            children: [
                asset && /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                    style: {
                        padding: `${asset === null || asset === void 0 ? void 0 : asset.assetVerticalPadding} 0`
                    }
                })),
                title && /*#__PURE__*/ _jsx("div", {
                    className: "title-wrapper",
                    children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread(_object_spread_props(_object_spread({}, EMPTY_ASSET_TITLE_PROPS), {
                        titleClassName: "asset-title"
                    }), title, advancedAssetTitleConfig))
                })
            ]
        });
    return /*#__PURE__*/ _jsx(StyledTimelineTitledTabTabsComponent, {
        className: "timeline-titled-tabs-component",
        style: {
            background: fullBackground && Colors[theme],
            "--tab-height": (tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabHeight) || `${TAB_LINE_HEIGHT}px`,
            "--tab-line-height": tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabLineHeight,
            "--tab-max-width": tabAdvancedConfig === null || tabAdvancedConfig === void 0 ? void 0 : tabAdvancedConfig.tabMaxWidth
        },
        children: /*#__PURE__*/ _jsx(VerticalTabs, _object_spread_props(_object_spread({
            fullBackground: fullBackground,
            tabsTitleRenderer: tabsTitleRenderer,
            tabContentRenderer: tabContentRenderer
        }, rest), {
            title: DEFAULT_TITLE,
            tabs: tabsWithClassNames,
            isDarkTheme: isDarkTheme(theme)
        }))
    });
};
TimelineTitledTabTabsComponent.defaultProps = DefaultProps;
export default TimelineTitledTabTabsComponent;
